import { makeAutoObservable } from 'mobx'

import { type AnalyticSession, onAnalyticEvent, onAnalyticPageView } from '../analytics'
import { BeatApi } from '../../core/api/BeatApi'
import type { Beat } from '../../core/types/Beat'

export interface ErrPromise<TSuccess, TError = unknown> {
  then<TResult1 = TSuccess, TResult2 = never>(
    onfulfilled?: ((value: TSuccess) => TResult1 | PromiseLike<TResult1>) | undefined | null,
    onrejected?: ((reason: TError) => TResult2 | PromiseLike<TResult2>) | undefined | null,
  ): Promise<TResult1 | TResult2>
  catch<TResult = never>(
    onrejected?: ((reason: TError) => TResult | PromiseLike<TResult>) | undefined | null,
  ): Promise<TSuccess | TResult>
}

export class InsightsMicroWidgetStore {
  onAnalyticEvent: (
    event: string,
    session: AnalyticSession,
  ) => ErrPromise<string, AnalyticSession> = onAnalyticEvent
  onAnalyticPageView: (
    event: string,
    session: AnalyticSession,
  ) => ErrPromise<string, AnalyticSession> = onAnalyticPageView

  beatApi = new BeatApi('/', '')

  constructor() {
    makeAutoObservable(this)
  }

  initialize = async (endpoint: string, token: string, logOutUser: () => void) => {
    this.onAnalyticEvent = (event: string, session: AnalyticSession): any => {
      onAnalyticEvent(event, session)
        .then((res) => res)
        .catch((err) => {
          if (err.status === 401) {
            logOutUser()
          }
          throw err
        })
    }

    this.onAnalyticPageView = (page: string, session: AnalyticSession): any => {
      onAnalyticPageView(page, session)
        .then((res) => res)
        .catch((err) => {
          if (err.status === 401) {
            logOutUser()
          }
          throw err
        })
    }

    this.beatApi = new BeatApi(endpoint, token)
  }

  updateBeat = async (beat: Beat) => {
    this.beatApi.updateBeat(beat)
  }

  updateOffer = async (beat: Beat) => {
    this.beatApi.updateOffer(beat)
  }
}
